import { render, staticRenderFns } from "./GAuthText.vue?vue&type=template&id=05e2dc70&scoped=true&"
import script from "./GAuthText.vue?vue&type=script&lang=ts&"
export * from "./GAuthText.vue?vue&type=script&lang=ts&"
import style0 from "./GAuthText.vue?vue&type=style&index=0&id=05e2dc70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e2dc70",
  null
  
)

export default component.exports